import { SVGProps } from 'react';

export const TextAlignLeftIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="12"
      viewBox="0 0 14 12"
      width="14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M0 0.55C0 0.246243 0.25128 0 0.56125 0H12.9087C13.2187 0 13.47 0.246243 13.47 0.55C13.47 0.853757 13.2187 1.1 12.9087 1.1H0.56125C0.25128 1.1 0 0.853757 0 0.55Z"
        fill="#474747"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M0 4C0 3.69624 0.226507 3.45 0.505917 3.45H8.04408C8.32349 3.45 8.55 3.69624 8.55 4C8.55 4.30376 8.32349 4.55 8.04408 4.55H0.505917C0.226507 4.55 0 4.30376 0 4Z"
        fill="#474747"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M0 7.45C0 7.14624 0.235944 6.9 0.526995 6.9H12.943C13.2341 6.9 13.47 7.14624 13.47 7.45C13.47 7.75376 13.2341 8 12.943 8H0.526995C0.235944 8 0 7.75376 0 7.45Z"
        fill="#474747"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M0 10.9C0 10.5962 0.222533 10.35 0.497041 10.35H7.90296C8.17747 10.35 8.4 10.5962 8.4 10.9C8.4 11.2038 8.17747 11.45 7.90296 11.45H0.497041C0.222533 11.45 0 11.2038 0 10.9Z"
        fill="#474747"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default TextAlignLeftIcon;
